import React from 'react';
import { Box } from '@mui/material';

export const FOOTER_TEST_ID = 'dashboard-mode-footer';

const DashboardModeFooter = ({ disclaimers = [] }) => {
  if (disclaimers.length === 0) {
    return null;
  }

  return (
    <Box mt={5} data-testid={FOOTER_TEST_ID}>
      {disclaimers.map((disclaimer, index) => (
        <p
          style={{ marginBottom: '10px' }}
          className="paragraph-10"
          key={index}
          data-testid={`footer-disclaimer-${index}`}
        >
          {disclaimer}
        </p>
      ))}
    </Box>
  );
};

export default DashboardModeFooter;
